export default __webpack_public_path__ + "static/media/hair_salon.970e7217.png";